import { createContext, useContext, useEffect } from 'react';

/**
 * Lets a page ask the site layout for the full browser width instead of the
 * default max-width container (used by the text editor's "full width" mode).
 */
export const PageWidthContext = createContext<(wide: boolean) => void>(() => {});

/** Request a full-width layout while `wide` is true; resets when the page unmounts. */
export const useFullWidthPage = (wide: boolean) => {
  const setWide = useContext(PageWidthContext);
  useEffect(() => {
    setWide(wide);
    return () => setWide(false);
  }, [wide, setWide]);
};
